import { Button, ButtonGroup, Heading, Icon, Paragraph, TextButton } from '@zillow/constellation-10';
import { IconHandshakeFilled } from '@zillow/constellation-icons';

import LeaseModal from '../../../Containers/LeaseModal';
import { FULLSTORY_EXCLUDE } from '../../../../constants/analytics';

type Props = {
  onClose(): void;
  propertyAddress: string;
  startSigning(): void;
};

export default function CountersigningRequestModal({ onClose, propertyAddress, startSigning }: Props) {
  return (
    <LeaseModal
      header={<Heading level={1}>Finalize your renewal</Heading>}
      isOpen
      onClose={onClose}
      body={
        <>
          <Icon size="lg" role="img" css={{ marginBottom: 'tight' }}>
            <IconHandshakeFilled />
          </Icon>
          <Heading
            level={2}
            css={{
              textStyle:
                'responsive.heading-xs' /* oxlint-disable-line constellation/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
              marginBottom: 'tight',
            }}
            className={FULLSTORY_EXCLUDE}
          >
            {propertyAddress
              ? `You are about to finalize the lease renewal agreement for ${propertyAddress}`
              : 'You are about to finalize the lease renewal agreement'}
          </Heading>
          <Paragraph>
            Everyone else has signed this lease renewal agreement, so it will be finalized with your signature. Review
            the entire lease renewal agreement before signing.
          </Paragraph>
        </>
      }
      footer={
        <ButtonGroup aria-label="countersign lease renewal">
          <TextButton tone="brand" onClick={onClose} data-test="countersign-later-button">
            Sign later
          </TextButton>
          <Button onClick={startSigning} tone="brand" emphasis="filled" data-test="countersign-button">
            Review and sign
          </Button>
        </ButtonGroup>
      }
    />
  );
}
